import { BuildMode } from "@/types";

enum FragileEvent {
  HomePage_AiTryClick = "colectio-clickai",
  HomePage_RegistrationSuccess = "colectio-registrace",
  AiPage_PageLoad = "colectio-aiidentikace",
  AiPage_UploadPhotoClick = "colectio-aiidentifikace-click-nahratfotografii",
}

export const Fragile = {
  Event: FragileEvent,

  trackEvent(event: FragileEvent): void {
    if (!isTrackingAllowed()) {
      return;
    }

    window._adftrack?.push({
      HttpHost: "track.adform.net",
      pm: 4069844, // Number received from Fragile agenture
      divider: encodeURIComponent("|"),
      pagename: encodeURIComponent(event),
    });
  },
} as const;

const isTrackingAllowed = (): boolean => {
  const allowedModes = [BuildMode.Production, BuildMode.Beta];
  const mode = import.meta.env.MODE as BuildMode;
  return allowedModes.includes(mode);
};
